import { combineReducers } from "redux";
import { ScopeLoadingState } from "./scope-loading/types";
import { ScopeErrorState } from "./scope-error/types";
import { scopeLoadingReducer } from "./scope-loading/reducer";
import { scopeErrorReducer } from "./scope-error/reducer";
import { UserState } from "./user/types";
import { userReducer } from "./user/reducer";
import { pendingContractReducer } from "./pending-contract/reducer";
import { PendingContractState } from "./pending-contract/types";
import { contractReducer } from "./contract/reducer";
import { ContractState } from "./contract/types";
import { ClaimState } from "./claim/types";
import { claimReducer } from "./claim/reducer";
import { UnRegisterReducer } from "./unregister-contract/reducer";
import { UnRegisterState } from "./unregister-contract/types";

export interface RootState {
  scopeLoading: ScopeLoadingState;
  scopeError: ScopeErrorState;
  claim: ClaimState;
  user: UserState;
  pendingContract: PendingContractState;
  contract: ContractState;
  unRegister: UnRegisterState;
}

const createRootReducer = () =>
  combineReducers({
    scopeLoading: scopeLoadingReducer,
    scopeError: scopeErrorReducer,
    user: userReducer,
    claim: claimReducer,
    pendingContract: pendingContractReducer,
    contract: contractReducer,
    unRegister: UnRegisterReducer,
  });

export default createRootReducer;
